export class ColorList {
  static readonly tagThemeVars: string[] = [
    'var(--tag-teal)',
    'var(--tag-blue)',
    'var(--tag-purple)',
    'var(--tag-amber)',
    'var(--tag-rose)',
  ];

  static readonly tagColors: string[] = [
    '#0d9488',
    '#2563eb',
    '#7c3aed',
    '#d97706',
    '#e11d48',
  ];

  static colors: string[] = [
    ...ColorList.tagColors,
    '#FF6B6B',
    '#FF8E72',
    '#FFA94D',
    '#FFD93D',
    '#EFFF6B',
    '#C6FF6B',
    '#96FF6B',
    '#6BFF8E',
    '#6BFFB8',
    '#6BFFF0',
    '#6BDBFF',
    '#6BB3FF',
    '#6B8BFF',
    '#8E6BFF',
    '#B46BFF',
    '#DA6BFF',
    '#FF6BEB',
    '#FF6BB8',
    '#FF6B8E',
    '#FF6B6B',
    '#FF9E9E',
    '#FFC39E',
    '#FFE69E',
    '#E6FF9E',
    '#B8FF9E',
    '#9EFFC3',
    '#9EFFE6',
    '#9EEDFF',
    '#9EC8FF',
    '#9EA3FF',
    '#B99EFF',
    '#D69EFF',
    '#F09EFF',
    '#FF9EDB',
    '#FF9EB8',
    '#FF9E9E',
    '#FFB8B8',
    '#FFD1B8',
    '#FFEAB8',
    '#E4FFB8',
    '#C3FFB8',
    '#B8FFD1',
    '#B8FFEA',
    '#B8F4FF',
    '#B8D7FF',
    '#B8BBFF',
    '#CDB8FF',
    '#E1B8FF',
    '#F7B8FF',
    '#FFB8E4',
    '#FFB8C3',
    '#FFB8B8',
    '#FF8C91',
    '#FFAE8C',
    '#FFD58C',
    '#EBFF8C',
    '#C6FF8C',
    '#8CFF91',
    '#8CFFB2',
    '#8CFFE1',
    '#8CD4FF',
    '#8CB1FF',
    '#8C8EFF',
    '#AF8CFF',
    '#D18CFF',
    '#F28CFF',
    '#FF8CDB',
    '#FF8CB2',
    '#FF8C91',
    '#FF7171',
    '#FF9871',
    '#FFC671',
    '#E9FF71',
    '#BCFF71',
    '#8FFF71',
    '#71FF97',
    '#71FFC3',
    '#71FFEF',
    '#71D4FF',
    '#71AFFF',
    '#7191FF',
    '#9371FF',
    '#B671FF',
    '#D871FF',
    '#F371FF',
    '#FF71C9',
    '#FF71A2',
    '#FF7171',
    '#FF5E6C',
    '#FF8B5E',
    '#FFC15E',
    '#E0FF5E',
    '#ACFF5E',
    '#7EFF5E',
    '#5EFF8B',
    '#5EFFB8',
    '#5EE6FF',
    '#5EBEFF',
    '#5E9EFF',
    '#825EFF',
    '#A85EFF',
    '#CD5EFF',
    '#F05EFF',
    '#FF5EE0',
    '#FF5EB8',
    '#FF5E8B',
    '#FF5E5E',
  ];
}
